import React, { useEffect, useState } from 'react';
import { CircleSpinner } from 'react-spinners-kit';
import { useDispatch, useSelector } from 'react-redux';
import { getQueryString } from '../../../helpers/url';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setExtraPax } from '../../../actions/reservationActions';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import ProductCard from '../../../components/ProductCard/ProductCard';
import ButtonReservation from '../../../components/Common/Button/ButtonReservation';
import Money from '../../../components/Common/Money/Money';
import styles from '../reservation.module.css';
import ChevronIcon from '../../../components/icons/chevronIcon';
import ProductModal from '../../../components/Common/ProductModal/ProductModal';
import ReservationTicketInfo from '../ReservationTicketInfo/ReservationTicketInfo';
import '../../../css/product-list.css';
import { setExtraHours } from '../../../actions/extraProductActions';
import ErrorBox from '../../../components/Common/ErrorBox/ErrorBox';

const ReservationExtraGroups = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const showId = getQueryString('showId');
  const showName = getQueryString('showName');
  const refReservationId = getQueryString('refReservationId');
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const initialOpenBarHours = useSelector((state) => state.extraProducts.hours);
  const mainProducts = useSelector((state) => state.reservation.products);
  const mainPaxQuantity = mainProducts
 .filter((p) => p.specialType === null || p.specialType === 'MENU_MAIN')
    .reduce((t, p) => t + p.quantity, 0);
  const extraProducts = useSelector((state) => state.extraProducts.items);
  const groupedBySpecialType = extraProducts.reduce((acc, producto) => {
    const { specialType } = producto;
    if (!acc[specialType]) acc[specialType] = [];
    acc[specialType].push(producto);
    return acc;
  }, {});

  const orderType = [
    'OPEN_BAR_HOURS',
    'EXTRAPAX',
    'KIDS',
    'PER_HOUR_ALL_PAX',
    'EXTRA_PRODUCT',
    'UNIQUE_EXTRA_PRODUCT',
  ];

  const [products, setProducts] = useState(extraProducts);
  const hasItems = products?.some((p) => p.quantity > 0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const hasOpenBarHours = groupedBySpecialType['OPEN_BAR_HOURS']?.length > 0;
  const [showOpenBarList, setShowOpenBarList] = useState(false);

  const hardcodedOpenBarProduct = {
    name: t('openBarHours'),
    title: t('additionalDrinks'),
    description: t('enjoyDrinksHours'),
    prices: { price: null },
    quantity: 0,
    specialType: 'NUMBER_OF_HOURS',
  };

  const [selectedOpenBarHours, setSelectedOpenBarHours] = useState(initialOpenBarHours || 0);
  const [errorOpenBar, setErrorOpenBar] = useState(false);

  const handleIncrementHardcoded = () => {
    setSelectedOpenBarHours((prev) => {
      if (prev === 0) {
        setShowOpenBarList(true);
        return 2;
      }
      return prev + 1;
    });
  };

  const handleDecrementHardcoded = () => {
    setSelectedOpenBarHours((prev) => {
      if (prev <= 2) {
        setShowOpenBarList(false);
        return 0;
      }
      return prev - 1;
    });
  };

  const getTotal = () => {
    let total = 0;
    extraProducts
      .filter((p) => p.quantity > 0)
      .forEach((product) => {
        if (product.specialType === 'EXTRAPAX') {
          total += product.quantity * product.prices.priceExtraPax;
        } else if (product.specialType === 'PER_HOUR_ALL_PAX') {
          total += product.quantity * product.prices.price * mainPaxQuantity;
        } else if (product.specialType === 'OPEN_BAR_HOURS') {
          total += product.quantity * product.prices.price * selectedOpenBarHours; 
        } else {
          total += product.quantity * product.prices.price;
        }
      });
    if (selectedOpenBarHours > 0 && hardcodedOpenBarProduct.prices.price) {
      total += selectedOpenBarHours * hardcodedOpenBarProduct.prices.price;
    }
    return total;
  };

  const handleIncrement = (index) => {
    let newProducts = [...products];
    if (newProducts[index].isExclusive) {
      newProducts
        .filter((p) => p.isExclusive && p.id !== newProducts[index].id)
        .forEach((p) => (p.disabled = true));
    }

    // if (newProducts[index].specialType === 'OPEN_BAR_HOURS') {
    //   let currentQuantity = newProducts[index].quantity || 0;
    //   if (currentQuantity < maxSelectableOpenBarHours) {
    //     newProducts[index].quantity = currentQuantity + 1;
    //   }
    //   return setProducts(newProducts);
    // }

    if (newProducts[index].specialType === 'EXTRAPAX') {
      newProducts[index].quantity = Math.min(
        newProducts[index].extraPax,
        newProducts[index].quantity ? newProducts[index].quantity + 1 : 1,
      );
    } else if (newProducts[index].specialType === 'NUMBER_OF_HOURS') {
      let newQuantity = newProducts[index].quantity || 0;
      if (newQuantity < 2) newQuantity = 2;
      else newQuantity += 1;
      newProducts[index].quantity = newQuantity;
    } else {
      let newQuantity = newProducts[index].quantity ? newProducts[index].quantity : 0;
      if (newQuantity === 0) newQuantity = newProducts[index].minQuantity;
      else newQuantity += 1;
      newProducts[index].quantity = newProducts[index].stock
        ? Math.min(newProducts[index].stock, newQuantity)
        : newQuantity;
    }
    setProducts(newProducts);
  };

  useEffect(() => {
    if (selectedOpenBarHours === 0) {
      setProducts((prevProducts) => {
        let updated = [...prevProducts];
        updated.forEach((product, index) => {
          if (product.specialType === 'OPEN_BAR_HOURS') {
            updated[index].quantity = 0;
          }
        });
        return updated;
      });
    }
  }, [selectedOpenBarHours]);
  useEffect(() => {
    const calcTotal = () => {
      let totalCalc = 0;

      products
        .filter((p) => p.quantity > 0)
        .forEach((product) => {
          if (product.specialType === 'EXTRAPAX') {
            totalCalc += product.quantity * product.prices.priceExtraPax;
          } else if (product.specialType === 'PER_HOUR_ALL_PAX') {
            totalCalc += product.quantity * product.prices.price * mainPaxQuantity;
          } else {
            totalCalc += product.quantity * product.prices.price;
          }
        });

      if (selectedOpenBarHours > 0 && hardcodedOpenBarProduct.prices.price) {
        totalCalc += selectedOpenBarHours * hardcodedOpenBarProduct.prices.price;
      }

      setTotal(totalCalc);
    };

    calcTotal();
  }, [products, selectedOpenBarHours, mainPaxQuantity, hardcodedOpenBarProduct]);

  useEffect(() => {
    if (selectedOpenBarHours === 0 && errorOpenBar) {
      setErrorOpenBar(false);
    }
  }, [selectedOpenBarHours, errorOpenBar]);

  useEffect(() => {
    if (initialOpenBarHours > 0) {
      setSelectedOpenBarHours(initialOpenBarHours);
      setShowOpenBarList(true);
    }
  }, [initialOpenBarHours]);

  const handleDecrement = (index) => {
    let newProducts = [...products];
    let currentQuantity = newProducts[index].quantity;

    if (newProducts[index].specialType === 'NUMBER_OF_HOURS') {
      if (currentQuantity <= 2) newProducts[index].quantity = 0;
      else newProducts[index].quantity = currentQuantity - 1;
    } else {
      let newQuantity = currentQuantity - 1;
      if (newQuantity < newProducts[index].minQuantity) newQuantity = 0;
      newProducts[index].quantity = Math.max(0, newQuantity);
    }

    if (newProducts[index].isExclusive && newProducts[index].quantity === 0) {
      newProducts.forEach((p) => (p.disabled = false));
    }
    setProducts(newProducts);
  };

  const handleContinue = () => {
    const hasOpenBarProductSelected = products.some(
      (p) => p.specialType === 'OPEN_BAR_HOURS' && p.quantity > 0,
    );
    dispatch(setExtraHours(selectedOpenBarHours));
    if (selectedOpenBarHours > 0 && !hasOpenBarProductSelected) {
      setErrorOpenBar(true);
      return;
    }
let finalProducts = products.map((p) => {
  if (p.specialType === 'OPEN_BAR_HOURS') {
    return { ...p, hours: selectedOpenBarHours };
  }
  return p;
});

if (selectedOpenBarHours > 0 && !finalProducts.some(p => p.specialType === 'OPEN_BAR_HOURS')) {
  finalProducts.push({ ...hardcodedOpenBarProduct, quantity: 1, hours: selectedOpenBarHours });
}

    let query = `?showId=${showId}`;
    if (refReservationId) query += `&refReservationId=${refReservationId}`;

    dispatch(setExtraPax(finalProducts.filter((p) => p.quantity !== undefined)));
    history.push({
      pathname: '/reservation-check-groups',
      search: query,
    });
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleAddProduct = (productId) => {
    const index = extraProducts.findIndex((p) => p.id === productId);
    handleIncrement(index);
  };
  const onInfoClick = (product) => {
    setSelectedProduct(product);
    toggleModal();
  };
  const renderProducts = (type, i) => {
    return (
      <div className='product-types' key={i}>
        <div className='bold'>{t('productType.' + type + '.title')}</div>
        <div className='font-small text-lighter-gray'>{t('productType.' + type + '.subTitle')}</div>
        <div className='mt-2'>
          {extraProducts.map((e, index) => {
            if (e.specialType === type) {
              return (
                <ProductCard
                  key={index}
                  product={e}
                  isExtraPax={e.specialType === 'EXTRAPAX'}
                  onlyOne={type === 'UNIQUE_EXTRA_PRODUCT'}
                  hasMoreInfo={true}
                  showDiscount={false}
                  onInfoClick={() => onInfoClick(e)}
                  handleIncrement={() => handleIncrement(index)}
                  handleDecrement={() => handleDecrement(index)}
                 mainPax={Number(mainPaxQuantity)}
                  center={true}
                  selectedOpenBarHours={
                    type === 'OPEN_BAR_HOURS' ? selectedOpenBarHours : undefined
                  } 
                />
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  };
  return loading ? (
    <div className='loaderDiv'>
      <CircleSpinner
        className='spinner-app mx-auto'
        style={{ margin: 'auto' }}
        size={40}
        color='var(--color-font-primary)'
      />
    </div>
  ) : (
    <>
      <Header  />
      <ContentApp menu={true}>
        <>
          <div className='bold font-normal'>{t('addAdditional')}</div>
          <div className='product-list mt-3'>
            {orderType.map((type, i) => {
              if (type === 'OPEN_BAR_HOURS' && hasOpenBarHours) {
                return (
                  <div key={`open-bar-${i}`}>
                    <div className=' product-types-bar'>
                      <div className='bold'>{hardcodedOpenBarProduct.title}</div>
                      <div className='font-small text-lighter-gray mb-2'>
                        {hardcodedOpenBarProduct.description}
                      </div>
                      <div>
                        <ProductCard
                          product={{ ...hardcodedOpenBarProduct, quantity: selectedOpenBarHours }}
                          hasMoreInfo={false}
                          onInfoClick={() => onInfoClick(hardcodedOpenBarProduct)}
                          handleIncrement={handleIncrementHardcoded}
                          handleDecrement={handleDecrementHardcoded}
                          mainPax={mainPaxQuantity}
                          centerName={true}
                        />
                      </div>

                      {errorOpenBar && (
                        <div className='mt-2'>
                          <ErrorBox title={'Seleccione al menos una barra.'} />
                        </div>
                      )}
                    </div>
                    {showOpenBarList && renderProducts(type, i)}
                  </div>
                );
              }
              if (groupedBySpecialType[type] && groupedBySpecialType[type].length > 0) {
                return renderProducts(type, i);
              }
              return null;
            })}
          </div>

          <div className='position-fixed w-100' style={{ bottom: 0, left: 0, zIndex: 2 }}>
            <div className='container'>
              <div className='row justify-content-center'>
                <div className='col-12 col-md-7 col-lg-6 p-0'>
                  <ButtonReservation
                    leftContent={
                      hasItems || selectedOpenBarHours > 0 ? (
                        <>
                          {t('total')} <Money value={getTotal()} />
                        </>
                      ) : (
                        t('noThanks')
                      )
                    }
                    rightContent={
                      hasItems || selectedOpenBarHours > 0 ? (
                        <>
                          {t('continue')} <ChevronIcon size={20} fillColor={'#000'} />
                        </>
                      ) : (
                        <ChevronIcon size={20} fillColor={'#000'} />
                      )
                    }
                    backgroundColor={
                      !hasItems && selectedOpenBarHours === 0 ? 'var(--color-deep-gray)' : null
                    }
                    size='large'
                    className={`${styles.btn}`}
                    onClick={handleContinue}
                    fixed={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      </ContentApp>
      <ProductModal
        open={isModalOpen}
        onClose={toggleModal}
        animationClass='slide-left-right'
        fullScreen={true}
        hasBackground={true}
        backIcon={true}
      >
        <ReservationTicketInfo
          productId={selectedProduct?.id}
          showAddButton={!selectedProduct?.hasSoldOut && selectedProduct?.stock > 0}
          handleIncrement={() => handleAddProduct(selectedProduct?.id)}
          prices={selectedProduct?.prices}
          toggleModal={toggleModal}
          isModalOpen={isModalOpen}
        />
      </ProductModal>
    </>
  );
};
export default ReservationExtraGroups;